export default __webpack_public_path__ + "static/media/key-command.ee6fa0cf.svg";